const config = {
  API_BASE_URL: 'https://complaint-classifier-backend.onrender.com'
};

export default config;